const CACHE_PREFIX = 'translation:'

function hashSource(sourceText, targetLocale) {
  const input = `${targetLocale}:${sourceText}`
  let hash = 5381

  for (let i = 0; i < input.length; i += 1) {
    hash = ((hash << 5) + hash) + input.charCodeAt(i)
    hash &= 0xffffffff
  }

  return Math.abs(hash).toString(36)
}

export function getCachedTranslation(storage, sourceText, targetLocale) {
  if (!storage) return ''

  try {
    return storage.getItem(`${CACHE_PREFIX}${hashSource(sourceText, targetLocale)}`) || ''
  } catch (e) {
    return ''
  }
}

export function setCachedTranslation(storage, sourceText, targetLocale, translatedText) {
  if (!storage || !translatedText) return

  try {
    storage.setItem(`${CACHE_PREFIX}${hashSource(sourceText, targetLocale)}`, translatedText)
  } catch (e) {
    // localStorage can be full or disabled. Translation still works without cache.
  }
}
